import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

/**
 * Método para obtener las empresas reagistradas en el sistema.
 *
 * @param {*} param0
 * @param {*} query contiene la información de las empresas.
 */
export async function getEmpresaFiltro({ commit, state }, query) {
    commit('dashboard/load', true, { root: true })
    await $http.get('/empresas/lista', {params: {nombre: query}})
        .then((response) => {
            commit('setListaEmpresa', response.data)
            state.error = false
        })
        .catch((error) => {
            commit('mensajeError', error.message)
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Método para obtener los documentos de una generales.
 *
 * @param {*} param0
 * @param {*} empresa generales a consultar.
 */
export async function getTreeEmpresa({commit, state}, empresa) {

    state.selectedDocumentos.Informationtree = [];
    commit('dashboard/load', true, {root: true});

    const params = (state.selectedDocument) ? {document_id:state.selectedDocument.id} : null;
    await $http.get(`empresas/adm_documentos/${empresa}`,{params:params})
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('cargarTreeEmpresa', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('mensajeError', error.message)
        })
}

/**
 * Método para guardar los documentos de una generales.
 *
 * @param {*} param0
 * @param {*} data contiene la infiormación del documento.
 */
export async function guardaAdj({commit, state, dispatch}, data) {

    commit('dashboard/load', true, { root: true })
    var empresa = state.selectedDocumentos.empresaId;

    data.append('descripcion', state.selectedDocumentos.descripcion);
    data.append('padre_id', state.selectedDocumentos.padre_id);
    data.append('adjunto', state.selectedDocumentos.adjunto);
    data.append('tipo', state.selectedDocumentos.tipo);

    await $http.post(`empresas/adm_documentos/${empresa}`, data)
        .then(async (response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true
            })
            commit('setSelectedDocument',{id:state.selectedDocumentos.padre_id});
            await dispatch('getTreeEmpresa', empresa)
        })
        .catch((error) => {
            commit('limpiarCampos')
            if (error.errors) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message,
                    showConfirmButton: true,
                    timer: 5000
                })
            }
        }).finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Método para editar los documentos de una generales.
 *
 * @param {*} param0
 * @param {*} data contiene la infromación del documento.
 */
export async function editaAdj({commit, state, dispatch}, data) {

    var empresa = state.selectedDocumentos.empresaId;

    data.append('text', state.selectedDocumentos.descripcion);
    data.append('padre_id', state.selectedDocumentos.padre_id);
    data.append('url', state.selectedDocumentos.adjunto);
    data.append('type', state.selectedDocumentos.tipo);
    data.append('id', state.selectedDocumentos.nodeActiveId);

    commit('dashboard/load', true, { root: true })
    await $http.post(`empresas/adm_documentos/editar/${empresa}`, data)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            })
            dispatch('getTreeEmpresa', empresa)
        })
        .catch((error) => {
            commit('limpiarCampos')
            if (error.errors) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message,
                    showConfirmButton: true,
                    timer: 5000
                })
            }
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Método para inactivar un documento de una generales.
 *
 * @param {*} param0
 * @param {*} data contiene la infromacion del documento.
 */
export async function eliminaNodo({commit, state, dispatch}, data) {

    var empresa = state.selectedDocumentos.empresaId;

    data.url = "";

    await $http.post(`empresas/adm_documentos/cambiaEstado/${empresa}`, data)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            })
            dispatch('getTreeEmpresa', empresa)
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para eliminar un documento de una generales.
 *
 * @param {*} param0
 * @param {*} data contiene la infromacion del documento.
 */
export async function eliminaDocumento({commit, state, dispatch}, id) {
    await $http.put(`empresas/adm_documentos/eliminar/${id}`, state.selectedDocumentos)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            })
            /* dispatch('getTreeEmpresa', id) */
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para guardar una carpeta del proceso.
 *
 * @param {*} param0
 */
export async function guardaFolder({commit, state, dispatch}) {

    commit('dashboard/load', true, { root: true })
    var empresa = state.selectedDocumentos.empresaId;

    await $http.post(`empresas/adm_documentos/${empresa}`, state.selectedDocumentos)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 3000
            })
            commit('limpiarCampos')
            dispatch('getTreeEmpresa', empresa)
        })
        .catch((error) => {
            commit('limpiarCampos')
            if (error.errors) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message,
                    showConfirmButton: true,
                    timer: 5000
                })
            }
        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Método para descargar un documento.
 *
 * @param {*} data contiene la informacion del documento.
 */
export async function descargarDocumento({commit, state}, data) {

    var empresa = state.selectedDocumentos.empresaId;
    commit('dashboard/load', true, {root: true});
    await $http.post(`empresas/adm_documentos/descargar/${empresa}`, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setUrlDocumento', response.data.url)
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: response.message,
                showConfirmButton: true,
                timer: 5000
            })
        })


    let nombre = '';
    let url = '';

    url = data.url.split('.');
    nombre = data.text + '.' + url[1];

    await $http({
        url: 'empresas/adm_documentos/descargar/' + empresa,
        method: 'POST',
        responseType: 'blob',
        data
    }).then((response) => {
        commit('dashboard/load', false, {root: true});
        window.downloadFile(response.data, nombre)
    }).catch((error) => {
        commit('dashboard/load', false, {root: true});
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.error,
            showConfirmButton: true,
            timer: 5000
        })
    })


}

/**
 * Método para descargar un documento.
 *
 * @param {*} data contiene la informacion del documento.
 */
export async function searchDocument({commit, state}, documentName) {
    if (documentName.length >= 3) {
        let companyId = state.selectedDocumentos.empresa;
        if(companyId && companyId !== undefined){
            commit('dashboard/load', true, {root: true});
            await $http.get(`empresas/adm_documentos/${companyId}/list?search=${documentName}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                console.log(response.data);
                commit('setDocuments', response.data.data)
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                this.$vue.$alertError(error.message);
            })
        }
    }
}


/**
 * Método seleacionar un documento a buscar
 *
 * @param {*} data contiene la informacion del documento.
 */
export async function changeSelectedDocument({commit, state,dispatch}, companyDocument) {
    commit('setSelectedDocument',companyDocument);
    dispatch('getTreeEmpresa', state.selectedDocumentos.empresa);
}
